import { render, staticRenderFns } from "./PersonalizationListView.vue?vue&type=template&id=190ba750&scoped=true"
import script from "./PersonalizationListView.vue?vue&type=script&lang=js"
export * from "./PersonalizationListView.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationListView.vue?vue&type=style&index=0&id=190ba750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ba750",
  null
  
)

export default component.exports